module.exports = __webpack_public_path__ + "static/media/gal2010-11.4f4df583.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/ressources/gal2010/gal2010-11.jpg
// module id = 564
// module chunks = 0